<div class="modal-body" *ngIf="isInitialized">
  <lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>

  <!-- Dropoff / pickup dates -->
  <div class="section">
    <lh-simple-time-period-picker
      [storageLocation]="shop"
      [disableFrom]="booking.status !== 'CONFIRMED'"
    ></lh-simple-time-period-picker>

    <div class="note">
      {{ 'CHOOSE_DATES_EXPLANATION' | translate }}
      <lh-shared-ui-tooltip
        [callToAction]="'MORE_INFO' | translate"
        [body]="'FLEXIBLE_BOOKINGS_TOOLTIP' | translate"
      ></lh-shared-ui-tooltip>
    </div>
  </div>

  <!-- Number of bags -->
  <div class="section" *ngIf="booking.status === 'CONFIRMED'">
    <lh-simple-bag-picker [maxBags]="shop.capacity.normal" *ngIf="shop"></lh-simple-bag-picker>
    <div class="alert alert-success" *ngIf="minBagsWarning">{{ minBagsWarning }}</div>
  </div>

  <!-- Pricing model -->
  <div class="section" *ngIf="booking.status === 'CONFIRMED' && !isGuest">
    <lh-pricing-model-selector
      [simpleMode]="true"
      [hourlyRate]="hourlyRate"
      [dailyRate]="dailyRate"
      [currency]="currency"
    ></lh-pricing-model-selector>
  </div>
</div>

<lh-ticket-stub dock="bottom">
  <lh-simple-order-summary
    [headline]="'SUMMARY' | translate"
    [isPaid]="false"
    [isCollapsed]="false"
    [isReadOnly]="booking?.status !== 'CONFIRMED'"
    [isLoading]="isUpdating"
    [order]="modifiedOrder || order"
    [callToAction]="promoCodeCta | translate"
    (callToActionClick)="showPromoCodeModal()"
    (orderLineChange)="onOrderLineChange($event)"
  ></lh-simple-order-summary>

  <div class="sticky-footer">
    <button
      id="saveBookingModifications"
      type="button"
      class="btn btn-block btn-warning btn-confirm"
      (click)="confirmChanges()"
      [disabled]="isLoading || isUpdating || !isModified || !canConfirmChanges"
    >
      <lh-shared-ui-spinner [visible]="isLoading"></lh-shared-ui-spinner>
      <span *ngIf="!isLoading">{{ 'CONFIRM_CHANGES' | translate }}</span>
      <div class="btn-overlay-inflate" *ngIf="isLoading || isUpdating || !isModified || !canConfirmChanges"></div>
      <lh-shared-ui-tooltip
        *ngIf="!isLoading && isModified && !canConfirmChanges"
        [body]="'LOCATION_NOT_AVAILABLE' | translate"
      ></lh-shared-ui-tooltip>
      <lh-shared-ui-tooltip
        *ngIf="!isLoading && !isModified"
        [body]="'NOT_MODIFIED_TOOLTIP' | translate"
      ></lh-shared-ui-tooltip>
    </button>
  </div>

  <div class="non-sticky-footer">
    <button
      id="abortModifyBooking"
      type="button"
      class="btn btn-md btn-link"
      (click)="close()"
      [disabled]="isLoading"
      tabindex="-1"
      *ngIf="!isModified || canConfirmChanges"
    >
      {{ 'DO_NOT_CHANGE' | translate }}
    </button>

    <div class="footnote">
      <!-- Not able to confirm with current selection -->
      <span *ngIf="isModified && !canConfirmChanges" class="text-danger">
        {{ 'LOCATION_NOT_AVAILABLE_WITH_YOUR_SELECTION' | translate }}
      </span>
    </div>
  </div>
</lh-ticket-stub>
